import moment from "moment";

const dateTimeToLocal = (dateTime, user = null) => {
	let timezone = localStorage.getItem("timezone")
		? localStorage.getItem("timezone")
		: user
		? user.timeZoneId
			? user.timeZoneId
			: moment.tz.guess()
		: moment.tz.guess();
	var stillUtc = moment
		.utc(dateTime)
		.tz(timezone)
		.format("MMMM Do YYYY HH:mm:ss a");
	return `${stillUtc} ${timezone}`;
};

export default dateTimeToLocal;
